import React from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../../../withRouter";
import BaseListPage from "../../../../../base/BaseListPage";
import InputFactory from "../../../../../components/InputFactory";
import AdditionalTalbePresenter from "../additional-info/AdditionalTalbePresenter";
import { DialogConfirmation } from "../../../../../components/common/Converter";
import Progress from "../../../../../components/Progress";

class WorkPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AdditionalTalbePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      initialData: [],
      position: "",
      department: "",
      salary: "",
      grade: "",
      appointment: "",
      objectID: "",
      govtService: "",
      email: sessionStorage.getItem("email"),
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  getCollectionName() {
    return "work_experience";
  }

  getCurrent() {
    return this.props.object.id;
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const newObject = await findObjectUseCase().execute("work_experience", {
      where: { empID: this.props.object.id },
    });
    this.setState({ initialData: newObject });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.objects !== this.state.objects) {
      const initialEmails = new Set(
        this.state.initialData.map((data) => data.position)
      );
      const newObjects = this.state.objects.filter(
        (data) => !initialEmails.has(data.position)
      );
      if (newObjects.length > 0) {
        localStorage.setItem("WorkExp", JSON.stringify(newObjects));
      }
    }
  }

  // delete function
  async handleDeleteData(data) {
    // const deletedData = await findObjectUseCase().execute("work_experience", {
    //   where: { id: id },
    // });
    // const prevDelete = JSON.parse(localStorage.getItem("DeleteWork")) || [];
    // const updatedDeleteData = prevDelete.concat(deletedData);
    // localStorage.setItem("DeleteWork", JSON.stringify(updatedDeleteData));

    // await this.presenter.deleteObjectUseCase.execute("work_experience", id);
    // dialog.close();
    // this.refetchData();
    DialogConfirmation(data.id, this.getCollectionName(), () =>
      this.refetchData()
    );
  }

  onChangeForm(field, value) {
    this.setState({ [field]: value });
  }

  // edit function
  handleObjectData(object) {
    this.setState({
      objectID: object.id,
      position: object.position || "",
      department: object.department || "",
      salary: object.salary || "",
      grade: object.grade || "",
      appointment: object.appointment || "",
      from: object.from || undefined,
      to: object.to || undefined,
      govtService: object.service || "",
    });
    console.log("object.slary", object.salary);
    dialog.fire({
      html: (
        <>
          <div className="m-2">
            <h4>Add Work Experience</h4>
            <hr />

            <form
              onSubmit={(e) => {
                e.preventDefault();
                this.handleSaveButton();
              }}
            >
              <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                Position Title (Write in full/Do not abbreviate){" "}
                <span style={{ color: "red" }}>*</span>
              </label>
              <InputFactory
                type="String"
                field="position"
                // object={object}
                required
                defaultValue={object.position}
                onChange={(value) => this.onChangeForm("position", value)}
              />

              <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                Department / Agency / Office / Company (Write in full / Do not
                abbreviate) <span style={{ color: "red" }}>*</span>
              </label>
              <InputFactory
                type="String"
                field="department"
                required
                // object={object}
                defaultValue={object.department}
                onChange={(value) => this.onChangeForm("department", value)}
              />

              <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                Monthly Salary
              </label>
              <InputFactory
                type="String"
                _type="parseNumber"
                field="salary"
                // object={object}
                defaultValue={object.salary}
                onChange={(value) => this.onChangeForm("salary", value)}
              />
              <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                Salary/Job/Pay Grade (if applicable) & Step (Format
                "00-0")/Increment
              </label>
              <InputFactory
                type="String"
                field="grade"
                defaultValue={object.grade}
                // object={object}
                onChange={(value) => this.onChangeForm("grade", value)}
              />

              <div style={{ margin: "1rem 0" }}>
                <h4>Government Service (If Applicable)</h4>
              </div>

              <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                Status of Appointment
              </label>
              <InputFactory
                type="String"
                field="appointment"
                // object={object}
                defaultValue={object.appointment}
                onChange={(value) => this.onChangeForm("appointment", value)}
              />

              <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                Gov't Service (Y/N)
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <label style={{ marginRight: "10px" }}>
                  <input
                    type="radio"
                    name="service"
                    object={object}
                    value="Y"
                    defaultChecked={this.state.service === "Y"}
                    onChange={this.onChangeService.bind(this)}
                  />{" "}
                  Y
                </label>
                <label style={{ marginRight: "10px" }}>
                  <input
                    type="radio"
                    name="service"
                    object={object}
                    value="N"
                    defaultChecked={this.state.service === "N"}
                    onChange={this.onChangeService.bind(this)}
                  />{" "}
                  N
                </label>
              </div>

              <div style={{ margin: "1rem 0" }}>
                <h4>Inclusive Dates (mm/dd/yyyy)</h4>
              </div>
              <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                From
              </label>
              <InputFactory
                type="Date"
                field="from"
                object={object}
                onChange={(value) => this.onChangeForm("from", value)}
              />

              <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                To
              </label>
              <InputFactory
                type="Date"
                field="to"
                object={object}
                onChange={(value) => this.onChangeForm("to", value)}
              />

              <div className="mt-4 mb-4 d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-light fs-sm me-3"
                  onClick={() => dialog.close()}
                >
                  Cancel
                </button>
                <button
                  // onClick={this.handleSaveButton.bind(this)}
                  type="submit"
                  className="btn btn-primary fs-sm me-3"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </>
      ),
      footer: false,
    });
  }

  onChangeService(event) {
    this.setState({ service: event.target.value });
  }

  async handleSaveButton() {
    if (this.state.objectID !== "") {
      const data = {
        email: this.props.object.email,
        empID: this.props.object.id,
        position: this.state.position,
        department: this.state.department,
        salary: this.state.salary,
        grade: this.state.grade,
        appointment: this.state.appointment,
        from: this.state.from,
        to: this.state.to,
        service: this.state.service,
        id: this.state.objectID,
      };
      await this.presenter.upsertUseCase.execute("work_experience", data);
      dialog.close();
      this.refetchData();
      this.setState({ objectID: "" });
    } else {
      const data = {
        email: this.props.object.email,
        empID: this.props.object.id,
        position: this.state.position,
        department: this.state.department,
        salary: this.state.salary,
        grade: this.state.grade,
        appointment: this.state.appointment,
        from: this.state.from,
        to: this.state.to,
        service: this.state.service,
      };
      console.warn("DATAAA: ", this.state.objectID);
      await this.presenter.upsertUseCase.execute("work_experience", data);
      dialog.close();
      this.refetchData();
    }
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit } = this.state;

    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();
    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <div className="d-flex align-items-center justify-content-center">
                  <div style={{ marginLeft: "auto" }}>
                    <Button
                      // onClick={this.handleAddRegion.bind(this)}
                      onClick={this.handleObjectData.bind(this)}
                    >
                      <i className="bi bi-plus-lg" /> Add Work Experience
                    </Button>
                  </div>
                </div>
              </div>

              <Table
                objectId={(data) => this.handleDeleteData(data)}
                objectData={this.handleObjectData.bind(this)}
                // editId={this.handleEditData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: "Remove",
                    actionType: "delete",
                  },
                  {
                    label: "Edit",
                    actionType: "object",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  [
                    "id",
                    "Created At",
                    "Updated At",
                    "salary",
                    "appointment",
                    "service",
                  ]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default WorkPage;
